import {
    Component,
    Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { QuestionCloseResult } from '@app/shared/models/components/question-close-result';
import { Questions } from '@app/shared/models/components/questions';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-question-dialog',
    templateUrl: './question-dialog.component.html',
    styleUrls: ['./question-dialog.component.scss'],
    imports: [
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        TranslateModule,
    ],
})
export class QuestionDialogComponent {
    /** Possible results for closing the modal dialog. */
    modalResult = QuestionCloseResult;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            msg: string;
            iconClass: string;
            icon: string;
            headline: string;
            confirmText: string;
            cancelText: string;
            hideCancelButton?: boolean;
            refNumber: string;
        },
        private dialogRef: MatDialogRef<QuestionDialogComponent>
    ) {}

    /**
     * Closes the dialog and sets the clsoing result.
     * @param result
     */
    closeWithResult(result: QuestionCloseResult): void {
        this.dialogRef.close(result);
    }
}
